// Autogenerated file
export const routerProfilesEnum = {
    HgvOptimal: "HgvOptimal",
    HgvShortest: "HgvShortest",
    Hgv15tOptimal: "Hgv15tOptimal",
    Lcv: "Lcv",
};
export const routerProfiles = [
    { label: "Оптимальный", value: "HgvOptimal" },
    { label: "Короткий", value: "HgvShortest" },
    { label: "Оптимальный, до 15 тонн", value: "Hgv15tOptimal" },
    { label: "До 3.5 тонн", value: "Lcv" },
];
